export default __webpack_public_path__ + "static/media/drogaraia-drogasil.dc884dbd.png";